<div class="progress" style="height: 10px">
  <div
    class="progress-bar bg-success"
    role="progressbar"
    [style.width]="progress + '%'"
  ></div>
</div>
